// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { RSVP } = initSchema(schema);

export {
  RSVP
};